import "./GchGalleryStyles.css";
import antiPlastic1 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-1.jpg";
import antiPlastic2 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-2.jpg";
import antiPlastic3 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-3.jpg";
import antiPlastic4 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-4.jpg";
import antiPlastic5 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-5.jpg";
import antiPlastic6 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-6.jpg";
import antiPlastic7 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-7.jpg";
import antiPlastic8 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-8.jpg";
import antiPlastic9 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-9.jpg";
import antiPlastic10 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-10.jpg";
import antiPlastic11 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-11.jpg";
import antiPlastic12 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-12.jpg";
import antiPlastic13 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-13.jpg";
import antiPlastic14 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-14.jpg";
import antiPlastic15 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-15.jpg";
import antiPlastic16 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-16.jpg";
import antiPlastic17 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-17.jpg";
import antiPlastic18 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-18.jpg";
import antiPlastic19 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-19.jpg";
import antiPlastic20 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-20.jpg";
import antiPlastic21 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-21.jpg";
import antiPlastic22 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-22.jpg";
import antiPlastic23 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-23.jpg";
import antiPlastic24 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-24.jpg";
import antiPlastic25 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-25.jpg";
import antiPlastic26 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-26.jpg";
import antiPlastic27 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-27.jpg";
import antiPlastic28 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-28.jpg";
import antiPlastic29 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-29.jpg";
import antiPlastic30 from "../Assets/Gallery/AntiPlastic/AntiPLasticCampaign-30.jpg";

function AntiPlasticActivities() {
  return (
    <div className="gallery-container">
      <div className="GCH-event-activity-heading">
        <h4>Anti Plastic Campaign - Beach Cleaning</h4>
      </div>
      <div className="GCH-event-activity-gallery">
        <div>
          <img alt="child-image" src={antiPlastic1} />
          <img alt="child-image" src={antiPlastic2} />
          <img alt="child-image" src={antiPlastic3} />
          <img alt="child-image" src={antiPlastic4} />
          <img alt="child-image" src={antiPlastic5} />
          <img alt="child-image" src={antiPlastic18} />
          <img alt="child-image" src={antiPlastic19} />
          <img alt="child-image" src={antiPlastic22} />
          <img alt="child-image" src={antiPlastic25} />
          <img alt="child-image" src={antiPlastic28} />
          <img alt="child-image" src={antiPlastic30} />
        </div>
        <div>
          <img alt="child-image" src={antiPlastic7} />
          <img alt="child-image" src={antiPlastic8} />
          <img alt="child-image" src={antiPlastic9} />
          <img alt="child-image" src={antiPlastic10} />
          <img alt="child-image" src={antiPlastic11} />
          <img alt="child-image" src={antiPlastic12} />
          <img alt="child-image" src={antiPlastic20} />
          <img alt="child-image" src={antiPlastic23} />
          <img alt="child-image" src={antiPlastic26} />
          <img alt="child-image" src={antiPlastic29} />
        </div>
        <div>
          <img alt="child-image" src={antiPlastic6} />
          <img alt="child-image" src={antiPlastic13} />
          <img alt="child-image" src={antiPlastic14} />
          <img alt="child-image" src={antiPlastic15} />
          <img alt="child-image" src={antiPlastic16} />
          <img alt="child-image" src={antiPlastic17} />
          <img alt="child-image" src={antiPlastic21} />
          <img alt="child-image" src={antiPlastic24} />
          <img alt="child-image" src={antiPlastic27} />
        </div>
      </div>
    </div>
  );
}

export default AntiPlasticActivities;
